import { generateClient } from 'aws-amplify/api';

let client = null;

const getClient = () => {
  if (!client) {
    client = generateClient();
  }
  return client;
};

export const graphqlQuery = async (query, variables = {}) => {
  try {
    const result = await getClient().graphql({ query, variables });
    return result.data;
  } catch (error) {
    console.error('GraphQL query failed:', error);
    const message = error.errors?.[0]?.message || error.message || 'GraphQL request failed';
    throw new Error(message);
  }
};

export const graphqlMutation = async (mutation, variables = {}) => {
  try {
    const result = await getClient().graphql({ query: mutation, variables });
    return result.data;
  } catch (error) {
    console.error('GraphQL mutation failed:', error);
    const message = error.errors?.[0]?.message || error.message || 'GraphQL request failed';
    throw new Error(message);
  }
};

/**
 * Opens a GraphQL subscription and returns the underlying Amplify subscription
 * object. Call `.unsubscribe()` on the returned value to clean up.
 *
 * @param {string} subscription - the subscription document
 * @param {object} variables - subscription variables
 * @param {(data: object) => void} onData - invoked with the subscription payload
 * @param {(error: any) => void} [onError] - invoked on subscription error
 * @returns {{ unsubscribe: () => void }}
 */
export const graphqlSubscribe = (subscription, variables = {}, onData, onError) => {
  const observable = getClient().graphql({ query: subscription, variables });
  return observable.subscribe({
    next: ({ data }) => {
      if (onData) onData(data);
    },
    error: (error) => {
      console.error('GraphQL subscription error:', error);
      if (onError) onError(error);
    },
  });
};
